import { GetProps, SizableText, styled } from '@mythical/ui'

const MarketingHeading = styled(SizableText, {
  ff: '$extended',
  color: '$fgPrimary',
  size: '$7',
  letterSpacing: -0.56,
  textAlign: 'center',
  textTransform: 'uppercase',
  $gtSm: {
    size: '$10.5',
    letterSpacing: -1.12,
  },
})

export type MarketingHeadingProps = GetProps<typeof MarketingHeading>

export default MarketingHeading
